import {TradingAlertStatus} from "./TradingAlertStatus";
import {Comparator} from "../../../types/GenericTypes";
import {ascending, descending} from "../../../js/util/UtilFunctions";
import {TradingAlertRule} from "../rules/TradingAlertRule";
import {IsoDateTime} from "../../../pseudo-types/DateTypes";
import {HasCode} from "../HasCode";
import {Exchange} from "../../../instruments/exchange/Exchange";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";

export interface NewTradingAlertDefinition extends CodeAndExchange {
    readonly description: string;
    readonly rules: Array<TradingAlertRule>;
}

export interface TradingAlertDefinition extends NewTradingAlertDefinition {
    readonly id: number;
}

export interface TradingAlert extends TradingAlertDefinition {
    readonly status: TradingAlertStatus;
    readonly matched: IsoDateTime | null;
}

export function sortByMatchedDesc(): Comparator<TradingAlert> {
    return (a, b) => descending(a.matched!, b.matched!);
}

export function sortByCodeAsc(): Comparator<TradingAlert> {
    return (a, b) => ascending(a.code, b.code);
}
